
export const orders = {
    orderList: '订单列表',
    orderNo: '订单号',
    email: '邮箱',
    productName: '产品名称',
    amount: '金额',
    paidAt: '支付时间',
    noOrderRecords: '暂无订单记录',
    noOrders: '暂无订单',
    noOrdersDescription: '您还没有任何订单记录',
    status: '状态',
    credits: '积分',
    operations: '操作',
    refund: '退款',
    refunding: '退款中...',
    refundSuccess: '退款申请提交成功',
    refundFailed: '退款申请失败',
    refundConfirm: '确定要申请退款此订单吗？',
    refundNotAvailable: '不可退款',
    statusCompleted: '已完成',
    statusPending: '待处理',
    statusFailed: '失败',
    statusCancelled: '已取消',
    statusRefunded: '已退款'
  };
